export default {
  API: {
    endpoints: [
      {
        name: 'solsell',
        endpoint: process.env.API_ENDPOINT_SOLSELL,
      },
    ],
  },
  Auth: {
    region: 'ap-northeast-1', 
    userPoolId: process.env.COGNITO_USER_POOL_ID_SOLSEL,
    userPoolWebClientId: process.env.COGNITO_CLIENT_ID_SOLSEL, 
  }
}
